import { ItiHttpService } from "@/iti-core-react/services/iti-http-service.ts";
import { API } from "@/shared/api.ts";
import { AxiosRequestConfig } from "axios";
import { ErrorCategoryDto } from "../dtos/Support/error-categories-dto";
import { ReportDto } from "../dtos/Support/report-dto";
import { ReportResponseDto } from "../dtos/Support/report-response-dto";

export const SupportService = {
	async createUserReport(report: ReportDto): Promise<ReportResponseDto> {
		const formData = new FormData();

		formData.append("subject", report.subject);
		formData.append("description", report.description);
		formData.append("context", report.context);

		if (report.files && report.files.length > 0) {
			for (const file of report.files) {
				formData.append("files", file, file.name);
			}
		}

		return ItiHttpService.postMultiPart(API.report.createUserReport, formData);
	},
	async getErrorCategories(
		acceptLanguage?: string,
	): Promise<ErrorCategoryDto[]> {
		const config: AxiosRequestConfig | undefined = acceptLanguage
			? { headers: { "Accept-Language": acceptLanguage } }
			: undefined;

		return ItiHttpService.get(
			API.report.errorCategories,
			undefined,
			true,
			false,
			false,
			config,
		);
	},
};
